import { useCallback, useMemo } from 'react';
import { PromiseState } from 'react-refetch';
import {
  ITopUSMarketData,
  ITopUSMarketsProps,
} from 'components/data-containers/KPIs/types';

const useUSMarketRadioSpinsData = (
  USMarketsRadioSpinsData: PromiseState<ITopUSMarketsProps[]>
): ITopUSMarketData[] | undefined => {
  const normalizeMarketSpins = useCallback((el) => {
    const { entity, markets } = el;
    return { entity, data: markets };
  }, []);

  const USMarketRadioSpins = useMemo(() => {
    if (!USMarketsRadioSpinsData) return;
    if (USMarketsRadioSpinsData.fulfilled) {
      return USMarketsRadioSpinsData.value.map(normalizeMarketSpins);
    }
  }, [USMarketsRadioSpinsData, normalizeMarketSpins]);

  if (!USMarketsRadioSpinsData) return undefined;

  return USMarketRadioSpins;
};

export default useUSMarketRadioSpinsData;
